import React from "react";
import { Link } from "react-router-dom";
import useMyAccount from "../../../../hooks/useMyAccount";
import { useAuth } from "../../../../hooks/useAuth";

import { hasImage } from "../../../Products/components/ProductItem";
import { formatCurrency } from "../../../../util/formatters";

const CompanyProfile = ({ showDetailsButton }) => {
  const iconStyle = { color: "#EC1F25" };

  const { companyData } = useMyAccount();
  const { userInfo } = useAuth();

  const buyingLimitTotal = userInfo?.user_buying_limit ?? 0;
  const buyingLimitAvailable = userInfo?.user_buying_limit_available ?? 0;
  const buyingLimitUsedLast30Days =
    userInfo?.user_buying_limit_used_last_30_days ?? 0;

  const availableColor =
    buyingLimitAvailable > 0
      ? "var(--bs-success, #198754)"
      : "var(--ltn__secondary-color, #dc3545)";
  const usedColor = "var(--ltn__secondary-color, #dc3545)";

  return (
    <div className="ltn-author-introducing clearfix">
      <div>
        <div className="author-img">
          <img src={hasImage(companyData?.image)} alt="Author" />
        </div>
        <div className="author-info">
          <h6>Perfil Empresarial</h6>
          <h2 style={{ color: "#071C1F" }}>{companyData?.company_name}</h2>
          <div style={{ marginTop: "6px", fontSize: "12px", color: "#6c757d" }}>
            Limite de compra por usuário (empresa):{" "}
            <span style={{ color: "var(--bs-success, #198754)" }}>
              Total: {formatCurrency(buyingLimitTotal)}
            </span>{" "}
            |{" "}
            <span style={{ color: availableColor }}>
              Disponível: {formatCurrency(buyingLimitAvailable)}
            </span>{" "}
            |{" "}
            <span style={{ color: usedColor }}>
              Usado (30 dias): {formatCurrency(buyingLimitUsedLast30Days)}
            </span>
          </div>
          {companyData?.cashback_amount != null && (
            <div style={{ marginTop: "4px", fontSize: "12px", color: "#6c757d" }}>
              Cashback disponível da empresa:{" "}
              <span style={{ color: "var(--bs-success, #198754)", fontWeight: 600 }}>
                {formatCurrency(companyData.cashback_amount)}
              </span>
            </div>
          )}
          <div className="footer-address">
            <ul>
              <li>
                <div className="footer-address-icon">
                  <i className="fas fa-phone fa-rotate-90" style={iconStyle} />
                </div>
                <div className="footer-address-info">
                  <p>
                    <a href={`tel:${companyData?.phone}`}>{companyData?.phone}</a>
                  </p>
                </div>
              </li>
              <li>
                <div className="footer-address-icon">
                  <i className="far fa-envelope" style={iconStyle} />
                </div>
                <div className="footer-address-info">
                  <p>
                    <a href={`mailto:${companyData?.email}`}>
                      {companyData?.email}
                    </a>
                  </p>
                </div>
              </li>
              <li>
                <div className="footer-address-icon">
                  <i className="fas fa-briefcase" style={iconStyle} />
                </div>
                <div className="footer-address-info">
                  <p>{companyData?.company_name}</p>
                </div>
              </li>
              {showDetailsButton && (
                <li>
                  <Link
                    to="/minha-conta/perfil/detalhes-empresa"
                    className="theme-btn-1 btn btn-effect-1"
                    title="Ver detalhes da empresa"
                  >
                    <i className="fas fa-search" />
                    Ver detalhes
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyProfile;
